import React from "react";
const UploadedMatrix = () => {
  return (
    <div className="text-xs">
      <div className="lg:flex lg:flex-col mt-3 justify-between bg-gray-100 p-2 m-2 rounded-md">
        <aside className="table__pos__app min-h-[20vh] ">
          <table class="custom-table text-[12px]">
            <thead class="header-cell sticky top-0 w-98 z-0">
              <tr>
                <td className="text-right">S NO</td>
                <td className="text-left">EXPENSE TYPE</td>
                <td className="text-left">ROUTE ID</td>
                <td className="text-left">FROM</td>
                <td className="text-left">TO</td>
                <td className="text-left">MILEAGE</td>
                <td className="text-left">ROUTE DEFINED</td>
                <td className="text-left">CURRENT</td>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </aside>
      </div>
    </div>
  );
};

export default UploadedMatrix;
